module.exports = __webpack_public_path__ + "static/media/smartwatch.2ce94732.svg";